import React, { useContext } from "react"
import i18n from "i18n"
import PropTypes from "prop-types"
import { DataGridPro } from "@mui/x-data-grid-pro"

import { getCurrency } from "utils/functions"
import AuthContext from "context/auth/authContext"

const calculateDimensions = measure => {
  const { user } = useContext(AuthContext)

  const depth = typeof measure?.depth === "number" ? measure?.depth : 0
  const width = typeof measure?.width === "number" ? measure?.width : 0
  const height = typeof measure?.height === "number" ? measure?.height : 0
  const dimensions = []
  if (depth > 0) dimensions.push(depth)
  if (width > 0) dimensions.push(width)
  if (height > 0) dimensions.push(height)
  return dimensions.length > 0 ? dimensions.join(" × ") : "-"
}

const DeltaDetailsDataGrid = ({ details }) => {
  const { user } = useContext(AuthContext)
  const rows = details?.map((item, idx) => ({ id: idx, ...item })) || []

  const columns = [
    {
      field: "description",
      headerName: i18n.t("certMeasurements.description"),
      flex: 1,
      minWidth: 200,
    },
    {
      field: "quantity",
      headerName: i18n.t("certMeasurements.uds"),
      type: "number",
      width: 100,
    },
    {
      field: "dimensions",
      headerName: i18n.t("certMeasurements.dimensions"),
      width: 120,
      renderCell: params => calculateDimensions(params.row),
    },
    {
      field: "measure_delta",
      headerName: i18n.t("certMeasurements.variationUds"),
      type: "number",
      width: 120,
    },
    {
      field: "measure_delta_value",
      headerName: `${i18n.t("certMeasurements.variation")} ${user && user["custom:currency"] ? getCurrency(user["custom:currency"]) : ""}`,
      type: "number",
      width: 120,
    },
  ]

  return (
    <div style={{ width: "100%" }}>
      <DataGridPro
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10, 25]}
        disableSelectionOnClick
        density="compact"
        hideFooter
      />
    </div>
  )
}

DeltaDetailsDataGrid.propTypes = {
  details: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      quantity: PropTypes.number,
      measure_delta: PropTypes.number,
      measure_delta_value: PropTypes.number,
      height: PropTypes.number,
      width: PropTypes.number,
      depth: PropTypes.number,
    }),
  ),
}

export default DeltaDetailsDataGrid
